export default __webpack_public_path__ + "6f06f0209055a6d3be900352f2c70d9b.mp4";